import { ListItemButton, styled } from "@mui/material";

export const ListItemButtonStyled = styled(ListItemButton)(
  ({ theme: { palette, spacing, shape } }) => ({
    paddingLeft: spacing(1.5),
    paddingRight: spacing(1.5),
    paddingTop: spacing(1.25),
    paddingBottom: spacing(1.25),
    marginBottom: spacing(1),
    color: palette.common.white,
    borderRadius: shape.borderRadius,

    "&:hover": {
      backgroundColor: palette.main[800],
    },

    "&.Mui-selected": {
      backgroundColor: palette.main[800],
      "&:hover": {
        backgroundColor: palette.main[800],
      },
    },

    "& .MuiListItemIcon-root": {
      width: 20,
      minWidth: 0,
      marginRight: spacing(1),
      color: palette.common.white,

      "& svg": {
        width: 20,
      },
    },

    "& .MuiListItemText-root": {
      margin: 0,
      whiteSpace: "nowrap",

      "& .MuiTypography-body1": {
        fontSize: 14,
        color: palette.common.white,
      },
    },
  }),
) as typeof ListItemButton;
